<footer class="footer">
  <div class="footer__main">
    <div class="container footer__row">
      <div class="customer-service">
        <div class="customer-service-top">
          <div class="customer-service-headline">
            <h3>{{ 'habaCheckoutFooter.customerService.title' | cxTranslate }}</h3>
            <app-svg iconName="chat" dimension="1.5rem" />
          </div>
          <p>{{ 'habaCheckoutFooter.customerService.description' | cxTranslate }}</p>
        </div>
        <span>
          <a class="footer__link" href="tel:{{ phoneNumber }}">{{ phoneNumber }}</a>
        </span>
      </div>

      <div class="payment-methods">
        <h3>{{ 'habaCheckoutFooter.paymentMethods.title' | cxTranslate }}</h3>
        <div class="footer__payment">
          <div class="footer__payment__icons">
            @for (paymentMethod of paymentMethods; track paymentMethod.icon) {
              <a [routerLink]="['/s/agb']" fragment="4-lieferbedingungen-versandkosten">
                <app-svg
                  [iconName]="paymentMethod.icon"
                  [width]="paymentMethod.width"
                  [height]="paymentMethod.height"
                />
              </a>
            }
          </div>
        </div>
        <p>{{ 'habaCheckoutFooter.paymentMethods.note' | cxTranslate }}</p>
      </div>
    </div>
  </div>
</footer>
